/**
 * 本文件由 scripts/generate-spm-codes.mjs 生成，请勿手改；编码以评审确认后的 CSV 快照为准。
 * 页面终端：product_detail_wap（164 个 D 位坑位，16 个 C 位模块）。
 * 模块级曝光上报 module.code（A.B.C）；坑位级曝光与点击上报完整编码（A.B.C.D）。
 */
import type { SpmPageCodes } from '../types';
import { getSpmSitePrefix } from '../site';

const sitePrefix = getSpmSitePrefix();

export const PRODUCT_DETAIL_WAP_SPM_CODES = {
  accessory_recommendations: {
    code: `${sitePrefix}.product_detail_wap.accessory_recommendations`,
    'add_to_cart_{NNN}': `${sitePrefix}.product_detail_wap.accessory_recommendations.add_to_cart_{NNN}`,
    'favorite_{NNN}': `${sitePrefix}.product_detail_wap.accessory_recommendations.favorite_{NNN}`,
    'preview_accessory_{NNN}': `${sitePrefix}.product_detail_wap.accessory_recommendations.preview_accessory_{NNN}`,
  },
  color_variants: {
    code: `${sitePrefix}.product_detail_wap.color_variants`,
    'select_variant_{NN}': `${sitePrefix}.product_detail_wap.color_variants.select_variant_{NN}`,
  },
  frame_specifications: {
    code: `${sitePrefix}.product_detail_wap.frame_specifications`,
    open_product_details: `${sitePrefix}.product_detail_wap.frame_specifications.open_product_details`,
    show_pd_range_help: `${sitePrefix}.product_detail_wap.frame_specifications.show_pd_range_help`,
    show_progressive_help: `${sitePrefix}.product_detail_wap.frame_specifications.show_progressive_help`,
    show_rx_range_help: `${sitePrefix}.product_detail_wap.frame_specifications.show_rx_range_help`,
    toggle_measurement_unit: `${sitePrefix}.product_detail_wap.frame_specifications.toggle_measurement_unit`,
    toggle_specifications: `${sitePrefix}.product_detail_wap.frame_specifications.toggle_specifications`,
  },
  installment_information: {
    code: `${sitePrefix}.product_detail_wap.installment_information`,
    open_installment_details: `${sitePrefix}.product_detail_wap.installment_information.open_installment_details`,
  },
  lens_availability: {
    code: `${sitePrefix}.product_detail_wap.lens_availability`,
    open_lens_details: `${sitePrefix}.product_detail_wap.lens_availability.open_lens_details`,
    toggle_lens_availability: `${sitePrefix}.product_detail_wap.lens_availability.toggle_lens_availability`,
  },
  price_offers: {
    code: `${sitePrefix}.product_detail_wap.price_offers`,
    open_coupons: `${sitePrefix}.product_detail_wap.price_offers.open_coupons`,
    open_first_frame_offer: `${sitePrefix}.product_detail_wap.price_offers.open_first_frame_offer`,
    open_second_frame_offer: `${sitePrefix}.product_detail_wap.price_offers.open_second_frame_offer`,
  },
  product_gallery: {
    code: `${sitePrefix}.product_detail_wap.product_gallery`,
    'preview_image_{NNN}': `${sitePrefix}.product_detail_wap.product_gallery.preview_image_{NNN}`,
    'toggle_dimensions_{NN}': `${sitePrefix}.product_detail_wap.product_gallery.toggle_dimensions_{NN}`,
    try_on: `${sitePrefix}.product_detail_wap.product_gallery.try_on`,
  },
  product_quality: {
    code: `${sitePrefix}.product_detail_wap.product_quality`,
    toggle_quality_details: `${sitePrefix}.product_detail_wap.product_quality.toggle_quality_details`,
  },
  product_summary: {
    code: `${sitePrefix}.product_detail_wap.product_summary`,
    view_reviews: `${sitePrefix}.product_detail_wap.product_summary.view_reviews`,
  },
  recommended_products: {
    code: `${sitePrefix}.product_detail_wap.recommended_products`,
    'color_swatch_{NNN}_{NN}': `${sitePrefix}.product_detail_wap.recommended_products.color_swatch_{NNN}_{NN}`,
    'favorite_{NNN}': `${sitePrefix}.product_detail_wap.recommended_products.favorite_{NNN}`,
    'product_{NNN}': `${sitePrefix}.product_detail_wap.recommended_products.product_{NNN}`,
  },
  review_filters: {
    code: `${sitePrefix}.product_detail_wap.review_filters`,
    open_review_sort: `${sitePrefix}.product_detail_wap.review_filters.open_review_sort`,
    'review_filter_option_{NN}': `${sitePrefix}.product_detail_wap.review_filters.review_filter_option_{NN}`,
    sort_highest_rating: `${sitePrefix}.product_detail_wap.review_filters.sort_highest_rating`,
    sort_lowest_rating: `${sitePrefix}.product_detail_wap.review_filters.sort_lowest_rating`,
    sort_most_recent: `${sitePrefix}.product_detail_wap.review_filters.sort_most_recent`,
  },
  review_results: {
    code: `${sitePrefix}.product_detail_wap.review_results`,
    close_reviews: `${sitePrefix}.product_detail_wap.review_results.close_reviews`,
    mark_review_helpful: `${sitePrefix}.product_detail_wap.review_results.mark_review_helpful`,
    preview_review_image: `${sitePrefix}.product_detail_wap.review_results.preview_review_image`,
  },
  review_summary: {
    code: `${sitePrefix}.product_detail_wap.review_summary`,
    'preview_review_image_{NN}': `${sitePrefix}.product_detail_wap.review_summary.preview_review_image_{NN}`,
    view_featured_review: `${sitePrefix}.product_detail_wap.review_summary.view_featured_review`,
    view_reviews: `${sitePrefix}.product_detail_wap.review_summary.view_reviews`,
  },
  services_guarantees: {
    code: `${sitePrefix}.product_detail_wap.services_guarantees`,
    open_services_details: `${sitePrefix}.product_detail_wap.services_guarantees.open_services_details`,
    toggle_services_guarantees: `${sitePrefix}.product_detail_wap.services_guarantees.toggle_services_guarantees`,
  },
  size_guide_entry: {
    code: `${sitePrefix}.product_detail_wap.size_guide_entry`,
    open_size_chart: `${sitePrefix}.product_detail_wap.size_guide_entry.open_size_chart`,
  },
  sticky_purchase: {
    code: `${sitePrefix}.product_detail_wap.sticky_purchase`,
    add_to_cart: `${sitePrefix}.product_detail_wap.sticky_purchase.add_to_cart`,
    favorite: `${sitePrefix}.product_detail_wap.sticky_purchase.favorite`,
    frame_only: `${sitePrefix}.product_detail_wap.sticky_purchase.frame_only`,
    no_restock: `${sitePrefix}.product_detail_wap.sticky_purchase.no_restock`,
    notify_me_when_available: `${sitePrefix}.product_detail_wap.sticky_purchase.notify_me_when_available`,
    notify_me_when_in_stock: `${sitePrefix}.product_detail_wap.sticky_purchase.notify_me_when_in_stock`,
    select_lenses: `${sitePrefix}.product_detail_wap.sticky_purchase.select_lenses`,
    select_lenses_and_buy: `${sitePrefix}.product_detail_wap.sticky_purchase.select_lenses_and_buy`,
    subscribed: `${sitePrefix}.product_detail_wap.sticky_purchase.subscribed`,
  },
} as const satisfies SpmPageCodes;
